import { render, staticRenderFns } from "./MiniSuborder.vue?vue&type=template&id=f83953ce&"
import script from "./MiniSuborder.vue?vue&type=script&lang=js&"
export * from "./MiniSuborder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports